import { useEffect, useRef } from 'react'

type UseDirectContactFormLoadMoreOrderPagesParameters = {
  availableSubOrderCount: number
  canLoadMoreApiPagesWithinDateRange: boolean
  currentVisibleCount: number
  isValidating: boolean
  loadedPageCount: number | undefined
  setPageCount: (pageCount: number) => Promise<unknown>
}

export const useDirectContactFormLoadMoreOrderPages = ({
  availableSubOrderCount,
  canLoadMoreApiPagesWithinDateRange,
  currentVisibleCount,
  isValidating,
  loadedPageCount,
  setPageCount,
}: UseDirectContactFormLoadMoreOrderPagesParameters): void => {
  const requestedPageCountRef = useRef<number | null>(null)

  useEffect(() => {
    if (
      loadedPageCount !== undefined &&
      requestedPageCountRef.current !== null &&
      loadedPageCount >= requestedPageCountRef.current
    ) {
      requestedPageCountRef.current = null
    }

    if (
      !canLoadMoreApiPagesWithinDateRange ||
      isValidating ||
      loadedPageCount === undefined ||
      requestedPageCountRef.current !== null ||
      currentVisibleCount <= availableSubOrderCount
    ) {
      return
    }

    const requestedPageCount = loadedPageCount + 1

    requestedPageCountRef.current = requestedPageCount

    void setPageCount(requestedPageCount)
  }, [
    availableSubOrderCount,
    canLoadMoreApiPagesWithinDateRange,
    currentVisibleCount,
    isValidating,
    loadedPageCount,
    setPageCount,
  ])
}
